import { render, staticRenderFns } from "./TimeLimitedExtraFields.vue?vue&type=template&id=022c5432&"
import script from "./TimeLimitedExtraFields.vue?vue&type=script&lang=js&"
export * from "./TimeLimitedExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports